import { useContext, useMemo } from 'react';
import { SecuritiesSecurityParam } from '../type';
import { securitiesSecurityParamsContext } from '../context';
import { stringifyParams } from '../../../shared/utils/makeUrl';
import { useBondSAccId } from '../../../bonds';

export const useSecuritiesSecurityDefaultParams = (params: Partial<SecuritiesSecurityParam>): SecuritiesSecurityParam | null => {
  const {
    'S_ACC.ID': contextSAccId,
  } = useContext(securitiesSecurityParamsContext);
  const bondSAccId = useBondSAccId();
  const sAccId = params['S_ACC.ID'] ?? bondSAccId ?? contextSAccId;
  const defaultParams = useMemo(() => ({
    'S_ACC.ID': sAccId,
  }), [sAccId]);
  return defaultParams;
};

export const useSecuritiesSecurityStringifiedParams = () => {
  const contextParams = useSecuritiesSecurityDefaultParams({});
  if (contextParams == null) {
    return null;
  }
  if (Number.isNaN(contextParams['S_ACC.ID'])) {
    return null;
  }
  return stringifyParams(contextParams);
};
